import React, { useState, useEffect } from 'react';
import api from '../services/api';
import useToast from '../hooks/useToast';
import ToastContainer from '../components/ToastContainer';

const YeniZimmetPage = () => {
  const [newItem, setNewItem] = useState({
    name: '',
    category: '',
    serialNumber: '',
    assignedTo: '',
    department: '',
    location: '',
    status: 'Aktif',
    notes: ''
  });
  const [stats, setStats] = useState({
    total: 0,
    active: 0,
    maintenance: 0,
    inactive: 0
  });
  const { toasts, addToast, removeToast } = useToast();

  const fetchStats = async () => {
    try {
      const response = await api.getInventoryStats();
      if (response.success && response.data) {
        setStats(response.data);
      }
    } catch (error) {
      console.error('İstatistikler yüklenirken hata:', error);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const handleAddItem = async (e) => {
    e.preventDefault();
    try {
      const response = await api.createInventoryItem(newItem);
      if (response.success) {
        addToast('Yeni zimmet kaydı başarıyla oluşturuldu', 'success', 3000);
        setNewItem({
          name: '',
          category: '',
          serialNumber: '',
          assignedTo: '',
          department: '',
          location: '',
          status: 'Aktif',
          notes: ''
        });
        fetchStats();
      }
    } catch (error) {
      console.error('Zimmet kaydı oluşturulurken hata:', error);
      addToast('Zimmet kaydı oluşturulurken bir hata oluştu', 'error', 5000);
    }
  };

  return (
    <div className="modern-hr-page">
      <div className="container-fluid">
        <div className="modern-hr-header">
          <div className="modern-hr-header-content">
            <div className="modern-hr-header-text">
              <h1>Yeni Zimmet Kaydı</h1>
              <p>Yeni zimmet kaydı oluşturun ve mevcut istatistikleri görüntüleyin</p>
            </div>
            <div className="modern-hr-header-actions">
              <div className="modern-hr-stats">
                <div className="modern-hr-stat-item">
                  <i className="bx bx-plus"></i>
                  <span>Yeni Kayıt</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="modern-hr-widget">
              <div className="modern-hr-widget-header">
                <div className="modern-hr-widget-title">
                  <i className="bx bx-plus"></i>
                  <h4>Yeni Zimmet Kaydı</h4>
                </div>
              </div>
              <div className="modern-hr-widget-body">
                <form onSubmit={handleAddItem} className="modern-hr-form">
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Ürün Adı</label>
                        <input 
                          type="text" 
                          className="modern-hr-form-input"
                          value={newItem.name}
                          onChange={(e) => setNewItem({...newItem, name: e.target.value})}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Kategori</label>
                        <select 
                          className="modern-hr-form-select"
                          value={newItem.category}
                          onChange={(e) => setNewItem({...newItem, category: e.target.value})}
                          required
                        >
                          <option value="">Kategori seçin</option>
                          <option value="Bilgisayar">Bilgisayar</option>
                          <option value="Telefon">Telefon</option>
                          <option value="Monitör">Monitör</option>
                          <option value="Yazıcı">Yazıcı</option>
                          <option value="Diğer">Diğer</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Seri Numarası</label>
                        <input 
                          type="text" 
                          className="modern-hr-form-input"
                          value={newItem.serialNumber}
                          onChange={(e) => setNewItem({...newItem, serialNumber: e.target.value})}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Zimmetli Kişi</label>
                        <input 
                          type="text" 
                          className="modern-hr-form-input"
                          value={newItem.assignedTo}
                          onChange={(e) => setNewItem({...newItem, assignedTo: e.target.value})}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Departman</label>
                        <select 
                          className="modern-hr-form-select"
                          value={newItem.department}
                          onChange={(e) => setNewItem({...newItem, department: e.target.value})}
                          required
                        >
                          <option value="">Departman seçin</option>
                          <option value="İnsan Kaynakları">İnsan Kaynakları</option>
                          <option value="Bilgi İşlem">Bilgi İşlem</option>
                          <option value="Mali İşler">Mali İşler</option>
                          <option value="Operasyon">Operasyon</option>
                          <option value="Satın Alma">Satın Alma</option>
                          <option value="Diğer">Diğer</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Lokasyon</label>
                        <input 
                          type="text" 
                          className="modern-hr-form-input"
                          value={newItem.location}
                          onChange={(e) => setNewItem({...newItem, location: e.target.value})}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Durum</label>
                        <select 
                          className="modern-hr-form-select"
                          value={newItem.status}
                          onChange={(e) => setNewItem({...newItem, status: e.target.value})}
                        >
                          <option value="Aktif">Aktif</option>
                          <option value="Pasif">Pasif</option>
                          <option value="Bakımda">Bakımda</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-12">
                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Notlar</label>
                        <textarea 
                          className="modern-hr-form-textarea"
                          rows="3"
                          value={newItem.notes}
                          onChange={(e) => setNewItem({...newItem, notes: e.target.value})}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="modern-hr-form-actions">
                    <button type="submit" className="modern-hr-btn modern-hr-btn-primary">
                      <i className="bx bx-save"></i>
                      Zimmet Kaydet
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="modern-hr-widget">
              <div className="modern-hr-widget-header">
                <div className="modern-hr-widget-title">
                  <i className="bx bx-bar-chart"></i>
                  <h4>Zimmet İstatistikleri</h4>
                </div>
              </div>
              <div className="modern-hr-widget-body">
                <div className="modern-stats-grid">
                  <div className="modern-stats-item">
                    <div className="modern-stats-item-icon bg-primary">
                      <i className="bx bx-package"></i>
                    </div>
                    <div className="modern-stats-item-content">
                      <h5>{stats.total}</h5>
                      <small>Toplam Zimmet</small>
                    </div>
                  </div>
                  <div className="modern-stats-item">
                    <div className="modern-stats-item-icon bg-success">
                      <i className="bx bx-check-circle"></i>
                    </div>
                    <div className="modern-stats-item-content">
                      <h5>{stats.active}</h5>
                      <small>Aktif</small>
                    </div>
                  </div>
                  <div className="modern-stats-item">
                    <div className="modern-stats-item-icon bg-warning">
                      <i className="bx bx-wrench"></i>
                    </div>
                    <div className="modern-stats-item-content">
                      <h5>{stats.maintenance}</h5>
                      <small>Bakımda</small>
                    </div>
                  </div>
                  <div className="modern-stats-item">
                    <div className="modern-stats-item-icon bg-danger">
                      <i className="bx bx-x-circle"></i>
                    </div>
                    <div className="modern-stats-item-content">
                      <h5>{stats.inactive}</h5>
                      <small>Pasif</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </div>
  );
};

export default YeniZimmetPage;
